import React, { createContext, useContext, useReducer } from 'react';

const CartContext = createContext();

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_ITEM': {
      const existing = state.find(i => i.productId === action.payload.productId);
      if (existing) {
        return state.map(i =>
          i.productId === action.payload.productId
            ? { ...i, quantity: Math.min(i.quantity + 1, action.payload.stock) }
            : i
        );
      }
      return [...state, { ...action.payload, quantity: 1 }];
    }
    case 'REMOVE_ITEM':
      return state.filter(i => i.productId !== action.payload);
    case 'UPDATE_QTY':
      return state.map(i =>
        i.productId === action.payload.productId
          ? { ...i, quantity: action.payload.quantity }
          : i
      ).filter(i => i.quantity > 0);
    case 'CLEAR':
      return [];
    default:
      return state;
  }
};

export function CartProvider({ children }) {
  const [cart, dispatch] = useReducer(cartReducer, []);

  const addItem = (product) => dispatch({
    type: 'ADD_ITEM',
    payload: { productId: product._id, name: product.name, price: product.price, stock: product.stock, image: product.image },
  });
  const removeItem = (productId) => dispatch({ type: 'REMOVE_ITEM', payload: productId });
  const updateQty = (productId, quantity) => dispatch({ type: 'UPDATE_QTY', payload: { productId, quantity } });
  const clearCart = () => dispatch({ type: 'CLEAR' });

  const totalItems = cart.reduce((sum, i) => sum + i.quantity, 0);
  const totalPrice = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ cart, addItem, removeItem, updateQty, clearCart, totalItems, totalPrice }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
